import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import BackLink from '../components/BackLink';
import SiteHeader from '../components/SiteHeader';
import FooterExpanded from '../components/landing/FooterExpanded';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function GroupGalleryPage() {
  const { key } = useParams();
  const [data, setData] = useState(null);
  const [tab, setTab] = useState('all');
  const [err, setErr] = useState('');

  useEffect(() => {
    axios.get(`${API_URL}/api/group/${key}`).then(r => setData(r.data)).catch(() => setErr('Group not found'));
  }, [key]);

  if (err) return <div className="min-h-screen bg-midnight flex items-center justify-center text-text-light">{err}</div>;
  if (!data) return <div className="min-h-screen bg-midnight flex items-center justify-center text-champagne">Loading…</div>;

  const allMedia = data.auras.flatMap(a => (a.media || []).map(m => ({ ...m, auraTitle: a.title })));
  const visible = tab === 'all' ? allMedia : (data.auras.find(a => String(a.id) === tab)?.media || []);

  return (
    <div className="min-h-screen bg-midnight text-text-light">
      <SiteHeader />
      <div className="max-w-6xl mx-auto p-4 sm:p-6">
        <div className="mb-4"><BackLink to="/" label="Home" /></div>
        <h1 className="font-serif text-3xl sm:text-4xl text-champagne mb-6 break-words">{data.name}</h1>
        <div className="flex flex-wrap gap-2 mb-6 border-b border-white/10 pb-3">
          <TabBtn active={tab === 'all'} onClick={() => setTab('all')}>All</TabBtn>
          {data.auras.map(a => (
            <TabBtn key={a.id} active={tab === String(a.id)} onClick={() => setTab(String(a.id))}>{a.title}</TabBtn>
          ))}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {visible.map(m => (
            <div key={m.id} className="aspect-square bg-white/5 rounded overflow-hidden relative">
              {m.file_type === 'image' && <img src={`${API_URL}${m.url}`} alt={m.caption || 'Aura photo'} className="w-full h-full object-cover" />}
              {m.file_type === 'video' && <video src={`${API_URL}${m.url}`} className="w-full h-full object-cover" />}
              {m.file_type === 'text' && <div className="p-3 text-sm">{m.text_content}</div>}
            </div>
          ))}
        </div>
      </div>
      <FooterExpanded />
    </div>
  );
}

function TabBtn({ active, ...rest }) {
  return <button {...rest} className={`px-3 py-1 rounded ${active ? 'bg-champagne text-midnight' : 'bg-white/5'}`} />;
}
